import React from 'react';
import { motion } from 'framer-motion';

const IconAutomation = (props) => (
  <motion.svg {...props} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="28" stroke="currentColor" strokeWidth="4"/>
    <path d="M50 18V22" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M50 78V82" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M82 50L78 50" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M22 50L18 50" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M72.435 27.565L69.6066 30.3934" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M30.3934 69.6066L27.565 72.435" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M72.435 72.435L69.6066 69.6066" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M30.3934 30.3934L27.565 27.565" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M50 50L64 36" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
  </motion.svg>
);

export default IconAutomation;